<template>
  <div>
    <icon-logo
        class="logo"
        color="#32E6BE"
        :width="500"
        :height="100"
    />

    <el-form
        ref="signin"
        :model="signin"
        :rules="rules"
        label-position="top"
        @keyup.enter.native="submitLogin">
      <el-form-item label="E-mail" prop="login">
        <el-input v-model="signin.login" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="Пароль" prop="password">
        <el-input v-model="signin.password" show-password auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="load" @click="submitLogin">Войти</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import IconLogo from "@/components/icons/header/Logo";

export default {
  name: "Login",
  data() {
    return {
      load: !!0,
      signin: {
        login: null,
        password: null,
      },
      rules: {
        login: [
          {required: true, message: 'Ошибка e-mail', trigger: 'blur'},
          {type: 'email', message: 'Ошибка', trigger: ['blur', 'change']}
        ],
        password: [
          {required: true, message: 'Ошибка пароля', trigger: 'blur'},
        ]
      },
      error: null
    }
  },
  components: {IconLogo},
  computed: {},
  created() {
    document.title = 'Авторизация'
  },
  methods: {
    ...mapActions({
      login: 'auth/LOGIN',
    }),
    submitLogin() {
      if (this.load) return

      this.error = null
      this.$refs.signin.validate((valid) => {
        if (valid) {
          this.load = !!1

          this.login(this.signin).then(() => {
            this.$notify.success({
              title: 'Удачно...',
              message: 'Успешная авторизация'
            });

            this.$router.push('/')
          }).catch((response) => {
            this.$notify.error({
              title: 'Ошибка авторизации 😕',
              message: response.response.data.message
            });
          }).finally(() => {
            this.load = !!0
          })
        }
      })

    },
  }

}
</script>

<style scoped lang="scss">
.logo {
  margin: 0 auto 25px auto;
  display: block;
  max-width: 150px;
}
</style>
